import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TRAVEL_SERVICES } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';

@Component({
  selector: 'app-dmc-travel-services-input',
  templateUrl: './dmc-travel-services-input.component.html',
  styleUrls: ['./dmc-travel-services-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DmcTravelServicesInputComponent),
      multi: true,
    },
  ],
})
export class DmcTravelServicesInputComponent implements OnInit {

  @Input() data: string[] | undefined;
  @Input() invalidInput: any;

  @Input() disableServiceType: boolean = false;

  TRAVEL_SERVICES = TRAVEL_SERVICES;
  role: any;
  clientUserLoggedIn: any;


  selectedItems: string[] = [];
  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(
    private _globalService: GlobalService
  ) { }

  ngOnInit() {
    this.role = localStorage.getItem("Role");
  }

  ngOnChanges() {
  }

  writeValue(value: any): void {
    if (value) {
      this.selectedItems = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if necessary
  }

  onCheckboxChange(event: any, item: string): void {
    if (item === TRAVEL_SERVICES.TOUR_PACKAGE) {
      if (event.target.checked) {
        this.selectedItems = [TRAVEL_SERVICES.TOUR_PACKAGE, TRAVEL_SERVICES.HOTELS, TRAVEL_SERVICES.SIGHTSEEING];
      } else {
        this.selectedItems = [];
      }
    } else {
      if (event.target.checked) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems = this.selectedItems.filter(i => i !== item);
      }

      const allServices = [
        TRAVEL_SERVICES.HOTELS,
        TRAVEL_SERVICES.SIGHTSEEING,
      ];
      if (allServices.every(service => this.selectedItems.includes(service))) {
        if (!this.selectedItems.includes(TRAVEL_SERVICES.TOUR_PACKAGE)) {
          this.selectedItems.push(TRAVEL_SERVICES.TOUR_PACKAGE);
        }
      } else {
        this.selectedItems = this.selectedItems.filter(i => i !== TRAVEL_SERVICES.TOUR_PACKAGE);
      }
    }

    this.onChange(this.selectedItems);
  }

  isChecked(item: string): boolean {
    return this.selectedItems.includes(item);
  }

}
